import "../../../../../../styles/StayUptoDateCSS/SubComponents.css";
import { useLocation } from "react-router-dom";
import { useLoadYesterdayLinks } from "../../../../../../Utils/customHooks/UpToDateContent/useLoadYesterdayLinks";
import track, {
  TRACKING_TYPES,
} from "../../../../../../Utils/SupabaseServices/Track";
import EditLinksWrapper from "./EditLinksWrapper";
import DataSkeleton from "../../../../../../components/StayUpToDateComponent/UpToDateComponents/DataSkeleton";
import { useDomLoaded } from "../../../../../../hooks/DomLoadedContext";
import { StaticVariables } from "../../../../../../Utils/StaticVariables";
import { useMemo, useState } from "react";
import SeeMoreTile from "../../StructureTemplates/SeeMoreTile";
import DashboardCarouselStructure from "../../../../../../components/CarouselStructure/DashboardCarouselStructure";
import { getPostTitle } from "../../../../../../Utils/HelperFunction/HelperFunction";
import React from "react";
import NoPostMsg from "../../../../../../components/NoPostMsg/NoPostMsg";
const LinksWrapper = (props: any) => {
  const {
    user_id,
    username,
    numberOfDays,
    title,
    isLinks,
    isEdit,
    setIsEdit,
    isEditModalOpen,
    setIsEditModalOpen,
    refetch,
    component,
    setSelectedComponent,
    selectedComponent,
    brand_color,
    type,
    componentType,
  } = props;
  const {
    content_shape,
    content_sound,
    content_order,
    shoppable_content_filter,
    unique_id,
    route_name
  } = component;
  const domLoaded = useDomLoaded();
  const {
    isLoading: yesterdayLinksLoading,
    data: yesterdayLinksData,
    refetch: refetchLinks,
  }: any = useLoadYesterdayLinks(
    username,
    user_id,
    numberOfDays,
    component?.post_ids,
    component?.removed_postids,
    title,
    false,
    content_order,
    component?.display_name?.split(","),
    componentType
    //  "yesterday"
  );
  const showSocials =
    shoppable_content_filter === "content"
      ? StaticVariables().CONTENT_PLATFORMS
      : shoppable_content_filter === "products"
        ? StaticVariables().PRODUCT_PLATFORMS
        : null;

  // Separate the filtering logic in useMemo
  const filteredData = useMemo(() => {
    if (showSocials) {
      return (yesterdayLinksData || [])
        .filter((element: any) => element !== undefined)
        .filter((item: any) => showSocials.includes(item.platform));
    }
    return yesterdayLinksData;
  }, [yesterdayLinksData, showSocials]);
  const [isSoundOn, setIsSoundOn] = useState(component?.content_sound || false);

  const location = useLocation();
  function handleShop(
    postId: string,
    media_url: string,
    platform: any,
    name: any
  ) {
    track("Redirect to shop link", TRACKING_TYPES.EVENT, {
      pathname: location.pathname,
      details: {
        post_id: postId,
        media_url: media_url,
        platform: platform,
        name: name,
      },
      user_id: user_id,
      title: "Stay Up To Date",
    });
    // updateRefClick(postId, user_id);
  }
  return (
    <>
      <div>
        {yesterdayLinksLoading || !domLoaded ? (
          <>
            <div className="outer-container-subcomponents">
              <DataSkeleton dashboard={true} />{" "}
            </div>
          </>
        ) : (
          <div className="outer-container-subcomponents">
            {filteredData && filteredData.length ? (
              <div className="links-grid-container-subcomponents">
                {filteredData &&
                  filteredData.slice(0, 25).map((link: any, index: number) => (
                    <React.Fragment key={index}>
                      <DashboardCarouselStructure
                        key={index}
                        link={link}
                        index={index}
                        handleShop={handleShop}
                        title={title}
                        brand_color={brand_color}
                        isLinks={isLinks}
                        productName={type ? getPostTitle(link, type) : ""}
                        contentShape={
                          component?.content_shape
                        }
                        contentSound={component?.content_sound}
                        isSoundOn={isSoundOn}
                        type={type}
                      />
                    </React.Fragment>
                  ))}
                <SeeMoreTile
                  data={filteredData}
                  type={type}
                  unique_id={route_name || unique_id}
                  user_id={user_id}
                  username={username}
                  component={component}
                  total_count={filteredData?.length}
                />
              </div>
            ) : (
              <NoPostMsg message="No Content Added Yet" />
            )}
          </div>
        )}
      </div>

      <EditLinksWrapper
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
        title={title}
        refetch={refetch}
        component={component}
        setSelectedComponent={setSelectedComponent}
        selectedComponent={selectedComponent}
        refetchLinks={refetchLinks}
      />
    </>
  );
};

export default LinksWrapper;

// <React.Fragment
//   key={
//     link.post_id ||
//     `link-${
//       link.id || Math.random().toString(36).substr(2, 9)
//     }`
//   }
// >
//   {link?.product_image ? (
//     <ImagePostTag
//       data={link}
//       handleRedirect={handleShop}
//       title={title}
//       brand_color={brand_color}
//       isLinks={true}
//       isDashboard={true}
//       isHasMediaUrl={
//         link.type === "FEED" &&
//         link.platform !== "MISC-content"
//           ? true
//           : false
//       }
//       contentShape={content_shape == "sq" ? true : false}
//       contentSound={content_sound}
//     />
//   ) : link.media_url ? (
//     link.media_url.split(",").length > 1 &&
//     link.media_url
//       .split(",")
//       .every((url: any) => url.trim() !== "") ? (
//       <React.Fragment
//         key={`carousel-${
//           link.post_id || link.id || Math.random()
//         }`}
//       >
//         <ImagePostCarouselTag
//           post={link}
//           handleRedirect={handleShop}
//           title={title}
//           brand_color={brand_color}
//           isLinks={false}
//           isDashboard={true}
//           isHasMediaUrl={
//             link.type === "FEED" &&
//             link.platform !== "MISC-content"
//               ? true
//               : false
//           }
//           contentShape={
//             content_shape == "sq" ? true : false
//           }
//           contentSound={content_sound}
//         />
//       </React.Fragment>
//     ) : (
//       <React.Fragment
//         key={`standard-${
//           link.post_id || link.id || Math.random()
//         }`}
//       >
//         {link.product_image && link.product_image !== "" ? (
//           <React.Fragment
//             key={`product-${
//               link.post_id || link.id || Math.random()
//             }`}
//           >
//             <ImagePostTag
//               data={link}
//               handleRedirect={handleShop}
//               title={title}
//               brand_color={brand_color}
//               isLinks={true}
//               isDashboard={true}
//               isHasMediaUrl={
//                 link.type === "FEED" &&
//                 link.platform !== "MISC-content"
//                   ? true
//                   : false
//               }
//               contentShape={
//                 content_shape == "sq" ? true : false
//               }
//               contentSound={content_sound}
//             />
//           </React.Fragment>
//         ) : (
//           <React.Fragment
//             key={`media-${
//               link.post_id || link.id || Math.random()
//             }`}
//           >
//             {link.media_url.includes("video") ? (
//               <React.Fragment
//                 key={`video-${
//                   link.post_id || link.id || Math.random()
//                 }`}
//               >
//                 <VideoPostTag
//                   post={link}
//                   handleRedirect={handleShop}
//                   title={title}
//                   brand_color={brand_color}
//                   isLinks={true}
//                   isDashboard={true}
//                   thumbnail={link.thumbnail}
//                   isHasMediaUrl={
//                     link.type === "FEED" &&
//                     link.platform !== "MISC-content"
//                       ? true
//                       : false
//                   }
//                   type={type}
//                   contentShape={
//                     content_shape == "sq" ? true : false
//                   }
//                   contentSound={content_sound}
//                 />
//               </React.Fragment>
//             ) : (
//               <React.Fragment
//                 key={`image-${
//                   link.post_id || link.id || Math.random()
//                 }`}
//               >
//                 <ImagePostTag
//                   data={link}
//                   handleRedirect={handleShop}
//                   title={title}
//                   brand_color={brand_color}
//                   isLinks={true}
//                   isDashboard={true}
//                   isHasMediaUrl={
//                     link.type === "FEED" &&
//                     link.platform !== "MISC-content"
//                       ? true
//                       : false
//                   }
//                   contentShape={
//                     content_shape == "sq" ? true : false
//                   }
//                   contentSound={content_sound}
//                 />
//               </React.Fragment>
//             )}
//           </React.Fragment>
//         )}
//       </React.Fragment>
//     )
//   ) : (
//     <React.Fragment
//       key={`default-${
//         link.post_id || link.id || Math.random()
//       }`}
//     >
//       <ImagePostTag
//         data={link}
//         handleRedirect={handleShop}
//         title={title}
//         brand_color={brand_color}
//         isLinks={true}
//         isDashboard={true}
//         isHasMediaUrl={
//           link.type === "FEED" &&
//           link.platform !== "MISC-content"
//             ? true
//             : false
//         }
//         contentShape={content_shape == "sq" ? true : false}
//         contentSound={content_sound}
//       />
//     </React.Fragment>
//   )}
// </React.Fragment>
